import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
export function isNumber(n) {
  return !Number.isNaN(parseFloat(n)) && Number.isFinite(n);
}
export function isNumeric(value, numberFormat) {
  var result;
  var regex;
  switch (numberFormat) {
    case 'decimal_dot':
      regex = new RegExp('^(-?[0-9]{1,3}(?:,?[0-9]{3})*(?:.[0-9]+)?)$');
      result = regex.test(value);
      break;
    case 'decimal_comma':
      regex = new RegExp('^(-?[0-9]{1,3}(?:.?[0-9]{3})*(?:,[0-9]+)?)$');
      result = regex.test(value);
      break;
    default:
      result = isNumber(value);
      break;
  }
  return result;
}

/**
 * Gets a formatted number and returns a clean "decimal dot" number.
 *
 * Note: Input must be formatted according to the specified parameters
 * (symbol_right, symbol_left, decimal_separator).
 * @example input -> $1.20, output -> 1.2
 *
 * @param text              string The currency-formatted number.
 * @param symbolRight      string The symbol used on the right.
 * @param symbolLeft       string The symbol used on the left.
 * @param decimalSeparator string The decimal separator being used.
 *
 * @return float The unformatted numerical value.
 */
export function cleanNumber(text, symbolRight, symbolLeft, decimalSeparator) {
  var formattedNumber = '';
  var cleanNumbers = '';
  var floatNumber = '';
  var digit = '';
  var isNegative = false;

  // Converting to a string if a number has passed
  formattedNumber = text.toString();

  // Removing symbol in unicode format (i.e. &#4444;)
  formattedNumber = formattedNumber.replace(/&.*?;/g, '');

  // Removing symbol from text
  formattedNumber = formattedNumber.replace(symbolRight, '');
  formattedNumber = formattedNumber.replace(symbolLeft, '');

  // Removing all non-numeric characters
  _toConsumableArray(formattedNumber).forEach(function (number, index) {
    digit = formattedNumber.substr(index, 1);
    if (parseInt(digit, 10) >= 0 && parseInt(digit, 10) <= 9 || digit === decimalSeparator) {
      cleanNumbers += digit;
    } else if (digit === '-') {
      isNegative = true;
    }
  });

  // Removing thousand separators but keeping decimal point
  _toConsumableArray(cleanNumbers).forEach(function (number, index) {
    digit = parseInt(cleanNumbers.substr(index, 1), 10);
    if (digit >= 0 && digit <= 9) {
      floatNumber += digit;
    } else if (digit === decimalSeparator) {
      floatNumber += '.';
    }
  });
  if (isNegative) {
    floatNumber = "-".concat(floatNumber);
  }
  return parseFloat(floatNumber);
}
export function tryConvertFloat(text) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'decimal_dot';
  if (isNumeric(text, format)) {
    var decimalSeparator = format === 'decimal_comma' ? ',' : '.';
    return cleanNumber(text, '', '', decimalSeparator);
  }
  return text;
}
export function transformToNumberFormat(_ref) {
  var number = _ref.number,
    _ref$digits = _ref.digits,
    digits = _ref$digits === void 0 ? null : _ref$digits,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '-' : _ref$placeholder;
  if (Number.isNaN(parseFloat(number))) {
    return placeholder;
  }
  var options = digits !== null ? {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  } : {};
  return parseFloat(number).toLocaleString('de', options);
}